module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/gifs/onboarding-record-properties.gif"